export function hashCode(object: unknown) {
    const string = JSON.stringify(object);
    let hash = 0,
        i,
        chr;
    if (string.length === 0) return hash;
    for (i = 0; i < string.length; i++) {
        chr = string.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0;
    }
    return hash;
}

export function normalizePath(path: string, dir: string) {
    // handle relative path
    if (path[0] === "." && path[1] === "/") {
        return `${dir}${path.substring(1)}`;
    }
    return path;
}
